import React from "react";
import MovieComment from "../component/MovieComment";
import NavigationBar from "../component/Layout/NavigationBar";
function MovieCommentPage() {
  return (
    <>
      <NavigationBar />
      <MovieComment />
    </>
  );
}

export default MovieCommentPage;
